<template>
  <v-container>
    <v-card-text v-if="value.method != 'auto'">
      <v-col>
        <v-row class="ma-auto">
          <v-col>
            <h4>{{ $t("IPv4 setting") }}</h4>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t("IP address/Mask") }}
                    </th>
                    
                    <th class="text-left">
                      {{ $t("Remove") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item, n in value.addresses" :key="n">
                    <td>{{ item }}</td>     
                    <td>
                      <v-btn
                        color="red"
                        small
                        icon
                        class="ma-2 white--text"
                        @click="remove(item)"
                      >
                        <v-icon> mdi-minus </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row class="ma-auto">
          <v-col cols="12" md="3">
            <v-text-field
              dense
              outlined
              v-model="ipadress"
              :label="$t('Address')"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field dense outlined v-model="mask" :label="$t('Mask')">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
              dense
              outlined
              v-model="gateway"
              :label="$t('Gateway')"
            >
            </v-text-field>
          </v-col>
        
          <v-col cols="12" md="3" class="mt-2" align="right">
            <v-btn small @click="add"> {{ $t("Add") }}</v-btn>
          </v-col>
        </v-row>
        
        <v-row class="ma-auto">
          <v-col>
            <h4>{{ $t("DNS setting") }}</h4>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t("DNS addresses") }}
                    </th>
                    <th class="text-left">
                      {{ $t("Remove") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, n) in value.dns" :key="n">
                    <td>{{ item }}</td>

                    <td>
                      <v-btn
                        color="red"
                        small
                        icon
                        class="ma-2 white--text"
                        @click="removeDNS(item)"
                      >
                        <v-icon> mdi-minus </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              dense
              outlined
              v-model="dns"
              :label="$t('Dns')"
              @input="update('type', $event.target.value)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" align="right">
            <v-btn class="mt-2" small @click="addDNS">{{ $t("Add") }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card-text>
  </v-container>
</template>

<script>
export default {
  name: "NetworkSystemd",
  props: ["value"],
  data() {
    return {
      ipadress: "",
      mask: "",
      gateway: "",
      dns: "",
    };
  },
  methods: {
    update(key, value) {
      this.$emit("input", { ...this.value, [key]: value });
    },
    
    remove(key) {
      console.log(key);
      const na = this.value.addresses.filter(
        (v) => v !== key )
      this.$emit("input", { ...this.value, ["addresses"]: na });
    },
    add() {
      const na = this.value.addresses;
      na.push(this.ipadress);
      this.$emit("input", { ...this.value, ["addresses"]: na });
    },
    addDNS() {
      const na = this.value.dns;
      na.push(this.dns);
      this.$emit("input", { ...this.value, ["dns"]: na });
    },
    removeDNS(key) {
      console.log(key);
      const na = this.value.dns.filter((v) => v !== key );
      this.$emit("input", { ...this.value, ["dns"]: na });
    },
  },
};
</script>

